<template>
  <div>
    <v-layout row wrap>
      <v-flex xs6>
        <!-- {{selectedName}} -->
        <!-- {{selectedPatients.name || selectedName}} -->
        <b-autocomplete
          class="AutoWrapper"
          v-model="selectedPatientsComputed.name"
          :data="result"
          :disabled="this.selectedPatients.person_id !== ''"
          :open-on-focus="openOnFocus"
          :keep-first="keepFirst"
          :clear-on-select="clearOnSelect"
          field="name"
          placeholder="Select Patient"
          @input="searchByVal"
          @select="option => passSelected(option)"
        >
          <template slot="header">
            <el-button
              type="success"
              size="small"
              class="button--prescription-success"
              @click="takeMeToRegistration()"
            >+ New Registration</el-button>
          </template>

          <template slot-scope="props">
            <div class="media">
              <div class="media-left">
                <avatar :username="props.option.name" :size="30"></avatar>
              </div>
              <div class="media-content">
                {{ props.option.name }}
                <br>
                <small style="color: dimgray">{{ props.option.number }}</small>
              </div>
            </div>
          </template>
        </b-autocomplete>
      </v-flex>
      <v-flex xs6>
        <!-- <el-dropdown v-if="doctors.length > 1">
          <el-button>
            Select doctor name
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <div v-for="item in doctors" :key="item.doctor_id">
              <el-dropdown-item
                @click.native="getOption(item.clinic_id, item.doctor_id)"
              >{{ item.doctor_name }}</el-dropdown-item>
            </div>
          </el-dropdown-menu>
        </el-dropdown>-->

        <el-select
          v-model="doctor_id"
          default-first-option
          v-if="doctors.length > 1"
          placeholder="Select doctor name"
          style="width: 95%"
        >
          <el-option
            v-for="item in doctors"
            :key="item.doctor_id"
            :label="item.doctor_name"
            @click.native="getOption(item.clinic_id, item.doctor_id)"
            :value="item.doctor_id"
          ></el-option>
        </el-select>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex md6 sm6>
        <el-date-picker
          v-model="date"
          type="date"
          placeholder="Pick a day"
          format="yyyy/M/dd"
          value-format="yyyy-M-dd"
          defaultTime
          :picker-options="pickerOptions"
          @change="updateTimePickerMinTime"
        ></el-date-picker>
      </v-flex>
      <v-flex md6 sm6>
        <el-time-picker
          v-model="time"
          format="hh:mm A"
          value-format="HH:mm:ss"
          placeholder="Pick a time"
          :picker-options="{
          start: '08:30',
          step: '00:15',
          end: '23:45',
          minTime: this.timePickerMinTime
          }"
        ></el-time-picker>
      </v-flex>
    </v-layout>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <el-button
        v-if="this.time.length === 0 || this.date === null"
        flat
        type="default"
        @click.native="addToWaiting()"
      >Add to Waiting</el-button>
      <el-button v-else flat type="default" @click.native="addToQueue()">Add to Queue</el-button>
    </v-card-actions>
  </div>
</template>

<script>
import { mapState } from "vuex";
import $ from "jquery";
import { api, jQuery401Callback } from "../api.js";
import { store } from "../store.js";
import { axios, get, post } from "axios";
import VuetifyGoogleAutocomplete from "vuetify-google-autocomplete";
import { Notification } from "element-ui";
import Autocomplete from "vuejs-auto-complete";
import Avatar from "vue-avatar";
import { setTimeout } from "timers";

export default {
  name: "ExistingRegistration",
  mounted() {
    // console.log("mounted");
    this.searchByVal("");
    this.updateTimePickerMinTime();
    // this.patient_name_search()
    if (localStorage.getItem("doctors")) {
      this.doctors = JSON.parse(localStorage.getItem("doctors"));
      console.log("this.doctors", this.doctors);
      this.doctor_id = localStorage.getItem("doctor_id");
      this.clinic_id = localStorage.getItem("clinic_id");
      this.fetchDoctorName(this.doctor_id, this.doctors);
    }
  },
  props: {
    selectedPatients: {
      default: {
        name: "",
        person_id: ""
      },
      type: Object
    }
  },
  created() {
    // this.searchByVal("a");
  },
  // components:{
  //   Quasar
  // },
  components: {
    VuetifyGoogleAutocomplete,
    avatar: Avatar
    // Autocomplete
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          const newDate = Date.now();
          const onedayOffset = 3600 * 1000 * 24;
          const yesterdayWithOffset = newDate - onedayOffset;
          // return time.getTime() < Date.now();
          return time.getTime() < yesterdayWithOffset;
        }
      },
      timePickerMinTime: "",
      snackbar: false,
      snackbarColor: "",
      mode: "",
      timeout: 6000,
      snackbarText: "Hello, I'm a snackbar",
      loading: false,
      address: "",
      result: [
        {
          name: "",
          person_id: ""
        }
      ],
      date: null,
      // pt_name:null,
      menu: false,
      time: null,
      menu2: false,
      items: ["Add Patient", "Registration"],
      searchInput: "",
      selectedName: null,
      selectedPersonId: null,
      select: null,
      place: null,
      openOnFocus: true,
      keepFirst: false,
      clearOnSelect: false,
      doctors: [],
      doctor_id: "",
      doctor_name: ""
    };
  },
  watch: {
    searchInput(val) {
      if (!val) {
        return;
      }
      this.searchByVal(val);
    }
  },
  computed: {
    disabledTime(time) {
      const newTime = new Date();
      const getHours = newTime.getHours();
      const getMinutes = newTime.getMinutes();
      const hourMins = `${getHours}:${getMinutes}`;
      console.log(hourMins);
      return hourMins;
    },
    selectedPatientsComputed: {
      get() {
        console.log("Getter");
        console.log(this.selectedPatients);
        if (this.selectedPatients.person_id !== "") {
          this.passSelected(this.selectedPatients);
        }
        return this.selectedPatients;
      },
      set(newValue) {
        console.log("setter");
        this.passSelected(newValue);
      }
    }
  },

  methods: {
    fetchDoctorName(doctor_id, doctors) {
      let doc_id = parseInt(doctor_id);
      let arrayDes = doctors;
      let find = arrayDes.find(item => {
        return item.doctor_id === doc_id;
      });
      let res = find.doctor_name;
      this.doctor_id = res;
    },
    getOption(clinic_id, doctor_id) {
      console.log(clinic_id);
      console.log(doctor_id);
      // this.$router.push({
      //   path: "/dashboard/" + clinic_id + "/" + doctor_id
      // });
      localStorage.setItem("clinic_id", clinic_id);
      localStorage.setItem("doctor_id", doctor_id);
    },
    passSelected(option) {
      this.selectedName = option.name;
      this.selectedPersonId = option.person_id;
    },
    takeMeToRegistration() {
      // console.log(this.$parent.$parent.$parent.$data.dialog = true);
      this.$parent.$parent.$parent.$data.dialog = false;
      this.$router.push("/profile/add");
    },
    updateTimePickerMinTime(date) {
      this.time = "";
      let dt = date;
      let minTime = "";

      if (!dt) {
        dt = new Date();
      } else {
        dt = new Date(date);
      }
      const inputYear = dt.getFullYear();
      const inputMonth = Number(dt.getMonth() + 1);
      const inputDate = Number(dt.getDate());
      const inputParsedDate = `${inputYear}-${inputMonth}-${inputDate}`;

      const today = new Date();
      const todayYear = today.getFullYear();
      const todayMonth = Number(today.getMonth() + 1);
      const todayDate = Number(today.getDate());
      const todayParsedDate = `${todayYear}-${todayMonth}-${todayDate}`;

      if (inputParsedDate === todayParsedDate) {
        minTime = `${today.getHours()}:${today.getMinutes()}`;
      }

      console.log(`return → ${minTime}`);

      this.timePickerMinTime = minTime;

      return minTime;
    },
    searchByVal(val) {
      let token = localStorage.getItem("token", this.token);
      if (localStorage.getItem("doctors")) {
        this.doctors = JSON.parse(localStorage.getItem("doctors"));
        console.log("this.doctors", this.doctors);
        // this.doctor_id = localStorage.getItem("doctor_id");
        this.clinic_id = localStorage.getItem("clinic_id");
      }
      let person_search =
        this.doctors.length > 1
          ? "/v3/person_search?search="
          : "/person_search?search=";
      console.log("this.doctors", this.doctors);
      $.ajax({
        url: api + person_search + val,
        type: "GET",
        headers: {
          token: token
        },
        error: jQuery401Callback
      }).then(response => {
        console.log("response.details", response.details);
        if (response !== null)
          if (response.details.length > 0) {
            this.result = response.details;
          } else {
            this.result = undefined;
          }
      });
    },
    handleSelect(item) {
      console.log(item);
    },
    getAddressData(addressData, placeResultData, id) {
      this.address = addressData.locality;
      console.log("addressData", addressData.locality);
    },
    addPatientToDashboard(
      doctor_id,
      concat_datetime,
      place,
      personId,
      personName,
      waiting
    ) {
      if (!this.date || !this.time) {
        Notification({
          title: "Add Patients",
          message: "Please select Appointment Date & Time",
          type: "error"
        });
        return;
      }

      if (personId === null || personName.length === 0) {
        Notification({
          title: "Warning",
          message: "Select A Patient To Proceed",
          type: "warning"
        });
      } else {
        let token = localStorage.getItem("token", this.token);
        $.ajax({
          url: `${api}/appointments?doctor_id=${doctor_id}&time=${concat_datetime}&place=${place}&is_waiting=${waiting}&person_id=${personId}`,
          type: "POST",
          headers: {
            token: token
          },
          error: jQuery401Callback
        }).then(res => {
          console.log(res);
          if (res.status == true) {
            Notification({
              title: "Appointment posted",
              message: res.message,
              type: "success"
            });
            // this.$router.push({
            //   path:
            //     "/dashboard/" +
            //     localStorage.getItem("clinic_id") +
            //     "/" +
            //     localStorage.getItem("doctor_id")
            // });
            setTimeout(function() {
              window.location.reload();
            }, 1000);
          }
          if (res.status == false) {
            Notification({
              title: "Appointment exist",
              message: res.message,
              type: "warning"
            });
          }
        });
        //exnd of xhr

        // post(
        //   api +
        //     `/appointments?doctor_id=${doctor_id}&time=${concat_datetime}&place=${place}&is_waiting=${waiting}&person_id=${personId}`
        // ).then(res => {
        //   console.log(res.data.message);
        // });
        // /end of axios
      }
    },
    addToQueue() {
      let time = this.time;
      let date = this.date;
      let concat_datetime = date + " " + time;
      let place = this.address;
      let token = localStorage.getItem("token", this.token);
      let doctor_id = localStorage.getItem("doctor_id");
      let personId = this.selectedPersonId;
      let personName = this.selectedName;
      let waiting = Number("0");

      console.log("addToQueue");
      this.addPatientToDashboard(
        doctor_id,
        concat_datetime,
        place,
        personId,
        personName,
        waiting
      );
    },
    addToWaiting() {
      let place = this.address;
      let token = localStorage.getItem("token", this.token);
      let doctor_id = localStorage.getItem("doctor_id");
      let personId = this.selectedName;
      let personName = this.selectedPersonId;

      let waiting = Number("1");
      let Ztoday = new Date();
      let ZtodayYear = Ztoday.getFullYear();
      let ZtodayMonth = Number(Ztoday.getMonth() + 1);
      let ZtodayDate = Number(Ztoday.getDate());
      let ZtodayParsedDate = `${ZtodayYear}-${ZtodayMonth}-${ZtodayDate}`;
      let ZTimeNow = `${Ztoday.getHours()}:${Ztoday.getMinutes()}`;
      let concat_datetime = ZtodayParsedDate + " " + ZTimeNow;

      console.log("addToWaiting");
      console.log(personName);
      this.addPatientToDashboard(
        doctor_id,
        concat_datetime,
        place,
        personId,
        personName,
        waiting
      );
    }
  }
};
</script>
<style scoped>
.layout {
  padding: 1rem;
}
.card__actions {
  padding: 1rem;
}
.el-date-editor {
  width: 100%;
  padding-right: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/ExistingRegistration.vue